import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    dialogId: String,
  }

  DIALOG_OPEN_CLASS = 'components--modal__dialog--open'
  DIALOG_CONTROLLER = 'ui--modal--dialog'

  connect() {
    const bodyDialog = document.querySelector(`body > dialog#${this.dialogIdValue}`)
    const innerDialog = this.element.querySelector(`dialog#${this.dialogIdValue}`)

    if (bodyDialog != null && bodyDialog.getAttribute('open') != null) {
      // allow controller to reattach to an existing *open* dialog if it is (for example)
      // replaced by a turbo stream or frame
      this.dialog = bodyDialog
      this.element.removeChild(innerDialog)
    } else {
      // otherwise, replace the dialog with the new one
      this.dialog = innerDialog
      this.element.removeChild(innerDialog)
      innerDialog.setAttribute('data-controller', this.DIALOG_CONTROLLER)
      document.body.append(innerDialog)
      if (bodyDialog) document.body.removeChild(bodyDialog)
    }

    if (this.dialog == null) {
      throw new Error('Missing dialog in modal controller!')
    }

    this.element.addEventListener('modal:open', this.handleOpen)
    addEventListener('turbo:before-cache', this.handleBeforeCache)
  }

  disconnect() {
    removeEventListener('turbo:before-cache', this.handleBeforeCache)
    this.element.removeEventListener('modal:open', this.handleOpen)
  }

  handleOpen = () => {
    this.dialog.hidden = false
    requestAnimationFrame(() => {
      this.dialog.classList.add(this.DIALOG_OPEN_CLASS)
      this.dialog.showModal()
    })
  }

  handleBeforeCache = () => {
    // restore initial state, with dialog contained within element
    // connect remains idempotent in case this does not run for whatever reason
    if (document.body.contains(this.dialog)) {
      document.body.removeChild(this.dialog)
      this.dialog.removeAttribute('data-controller')
      this.dialog.removeAttribute('open')
      this.dialog.classList.remove(this.DIALOG_OPEN_CLASS)
      this.element.appendChild(this.dialog)
    }
  }
}
